// extracted by mini-css-extract-plugin
export default {"banner":"MessageBanner__banner--TKzuM"};